import styled from 'styled-components';
import { IAppContext } from "../../interfaces";

export const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  color: ${(p: IAppContext) => p.theme.skye.colors.textPrimary};
`;